/**
 * Event bus for managing custom events without the
 * React components.
 */
import { EventEmitter } from 'events';

const eventBus = new EventEmitter();
export default eventBus;

export const CUSTOM_EVENTS = {
  PORTAL_OPEN_DATEPICKER_DRAWER: 'portal-open-datepicker-drawer',
  PORTAL_DATEPICKER_MODE_UPDATE: 'portal-datepicker-mode-update',
  PORTAL_CLEAR_FILTERS_AND_SEARCH: 'portal-clear-filters-and-search',
  CLOSE_MOBILE_NAVIGATION: 'close-mobile-navigation',
};
